<script lang="ts">
    export let width = '27';
</script>

<svg xmlns="http://www.w3.org/2000/svg" {width} height="28" viewBox="0 0 27 28" class="fill-none stroke-1" stroke="currentColor">
    <circle cx="13.3821" cy="14.0257" r="12.7659" />
    <path d="M21.1584 24.0895C21.1584 19.542 17.6767 15.8555 13.3818 15.8555C9.08691 15.8555 5.60522 19.542 5.60522 24.0895" />
    <circle cx="13.3819" cy="9.90802" r="3.61701" />
</svg>
